import { render, staticRenderFns } from "./Profilo.vue?vue&type=template&id=20d64fce"
import script from "./Profilo.vue?vue&type=script&lang=js"
export * from "./Profilo.vue?vue&type=script&lang=js"
import style0 from "./Profilo.vue?vue&type=style&index=0&id=20d64fce&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports